// Trazos de la firma a mano (SignaturePad). Los puntos se guardan en las
// coordenadas del ancho "base": el del canvas cuando se empezó a firmar. Al
// girar el celular se dibujan escalados, sin cambiar lo guardado, así ir y
// volver de horizontal no achica la firma (bloque 5c, §17 ítem 86).
export type Punto = { x: number; y: number };
export type Trazo = Punto[];

/**
 * Escala para dibujar con el ancho actual: menor que 1 si el canvas es más
 * angosto que la base (se reduce igual en X e Y, sin deformar); 1 si es igual
 * o más ancho (la firma no se agranda ni se sale del alto).
 */
export function escalaFirma(anchoBase: number, anchoActual: number): number {
  if (anchoBase <= 0 || anchoActual <= 0) return 1;
  return Math.min(anchoActual / anchoBase, 1);
}

/** Punto tocado en pantalla → coordenadas base (el alto queda dentro del canvas). */
export function aBase(p: Punto, escala: number, alto: number): Punto {
  const s = escala > 0 ? escala : 1;
  return { x: p.x / s, y: Math.min(Math.max(p.y / s, 0), alto) };
}

/** Coordenadas base → pantalla con la escala actual. */
export function aPantalla(p: Punto, escala: number): Punto {
  return { x: p.x * escala, y: p.y * escala };
}
